import type { HardwareComponentType } from './types'

type HardwareProductImageSource = Pick<HardwareComponentType, 'is_exhibitor' | 'ordering_v2' | 'promotional_image'>

export function shouldShowHardwareProductImage(component: HardwareProductImageSource | undefined): boolean {
  if (!component) return false
  const ordering = component.ordering_v2 ?? []
  const isProductOnSegen = ordering.some(({ distributor }) => distributor === 'segen')
  return Boolean(component.is_exhibitor) || isProductOnSegen || ordering.filter((v) => v.is_available).length > 0
}

export function getHardwareProductImageUrlCandidates(
  component: Pick<HardwareComponentType, 'promotional_image' | 'ordering_v2'> | undefined
): (string | null | undefined)[] {
  if (!component) return []
  return [component.promotional_image, component.ordering_v2?.find(({ image_url: imageUrl }) => imageUrl)?.image_url]
}
